
export default {
    identCode: "",
}